<template>
  <div>
    <div class="card_form_box" v-loading="PageLoading">
      <div class="certificate">
        <div class="certificate_title">
          <p class="title_label"> 制作美标纺织品水洗唛</p>
          <p class="title_remake">根据ASTM D5489-18制作（Standard guide for care symbols for care instructions on textile products)</p>
        </div>
        <el-form :model="ruleForm" :rules="rules"  label-position="top" ref="ruleForm" label-width="300px" class="demo-ruleForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="号型" >
                <span slot="label">号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</span>
                <div class="Size_pos">
                  <el-input v-model="ruleForm.MODEL_TYPE"  style="width: 392px;"  maxlength="200" ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="成分含量">
                <span slot="label">成分含量 <span class="label_tit" > (多个成分分开添加) </span></span>
                <div v-for="(domain, index) in ruleForm.COMPONENT" :key="index" style="display:flex;margin-bottom: 5px;align-items: center;">
                  <div>
                    <el-input v-model="domain.attrValue" style="width: 250px;" maxlength="50"  placeholder="请填写成分名称"></el-input>
                  </div>
                  <div class="label_number">
                    <el-input-number v-model="domain.attrRate"
                                     :controls="false"
                                     style="width: 90px;margin-left: 12px;"
                                     :precision="2"
                                     :min="0.00"
                                     :max="100"
                                     maxlength="3"
                                     @change="ChangeValue(index)"
                                     placeholder="填写百分比含量"
                    >
                    </el-input-number>
                    <div class="Symbol">
                      %
                    </div>
                  </div>
                  <div @click="addDomain" style="cursor: pointer;">
                    <img src="../../assets/images/add.png" >
                  </div>
                  <div @click.prevent="removeDomain(domain)" v-if="index !==0" style="margin-left: 10px;cursor: pointer">
                    <img src="../../assets/images/minus.png" >
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="请选择洗涤方法">
                <span slot="label">请选择洗涤方法 <span class="label_tit" > (点击符号可选) *</span></span>
                <div class="icon_box" id="showDiv">
                  <div v-for="(item,index) in ruleForm.AllIconList" :key="index" class="icon_box_list" >
                    <div class="icon_name">
                      <span>{{item.iconName}}</span>
                      <span v-if="item.multiple">(可多选)</span>
                    </div>
                    <div class="check_icon" @click="ChangeIcon(item,index)" id="showImgBox">
                      <div v-for="(y,ind) in item.checkIcon" :key="ind" class="check_img">
                        <img :src="y.enumName" alt=""  />
                      </div>
                    </div>

                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="请选择展示模式">
                <span slot="label">请选择展示模式 <span>（不同展示模式的效果请见右侧预览）</span></span>
                <el-radio-group v-model="ruleForm.showMode">
                  <el-radio :label="1">图片和文字模式</el-radio>
                  <el-radio :label="2">纯图片模式</el-radio>
                  <el-radio :label="3">纯文字模式</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="洗涤提醒">
                <el-input
                    type="textarea"
                    placeholder="如有警示语，请填写"
                    v-model="ruleForm.textarea"
                    maxlength="200"
                    :autosize="{ minRows: 4, maxRows: 6}"
                    style="width: 852px;"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="70%">
      <div slot="title" class="header-title">
        <span  class="name">
          请选择洗涤方法  <span class="name_tit" v-if="this.IconList.multiple">（最多选2个）</span>
        </span>
      </div>
<!--      水洗样式-->
      <div class="Optional_icon1" v-if="IconList.iconKey==='ICON.SL_WATER_USA'">
        <div v-for="(s,ind2) in IconList.AllIconList" :key="ind2" class="Optional_icon_list" >
          <div class="optional_text">
            <div :class="{'optional_remake':true}" v-html="s.remark">
            </div>
            <div class="img_list">
              <div class="list_index" v-for="(y,ind3) in s.children" :key="ind3">
                <div class="optional_or" v-if="ind3%2===1">
                  or
                </div>
                <div :class="{'optional_img':true,'active_optional_img':GetWaterActive(IconList.checkIcon,y.enumCode)}" @click="AddWaterCheckIcon(s,y)">
                  <img :src="y.enumName" alt=""  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      干燥样式-->
      <div class="Optional_icon2" v-if="IconList.iconKey==='ICON.SL_DRY_USA'">
          <div v-for="(s,ind2) in IconList.AllIconList" :key="ind2" class="Optional_icon_list"  >
            <div class="title">
              <span v-if="s.isFill===0">
                {{s.enumExtend}}
              </span>
            </div>
            <div class="optional_text_box">
              <div class="optional_text" v-for="(y,ind3) in s.children" :key="ind3" @click="AddCheckIcon(y)">
                <div :class="{'optional_img':true,'active_optional_img':GetDryActive(IconList.checkIcon,y.configId)}">
                  <img :src="y.enumName" alt=""  />
                </div>
                <div :class="{'optional_remake':true,'Active_Remake':GetDryActive(IconList.checkIcon,y.configId)}">
                  {{y.remark}}
                </div>
              </div>
            </div>

          </div>
      </div>
<!--     干洗样式 -->
      <div class="Optional_icon3" v-if="IconList.iconKey==='ICON.SL_DRY_CLEAN_USA'">
        <div v-for="(s,ind2) in IconList.AllIconList" :key="ind2" class="Optional_icon_list"  >
          <div class="title" >
            <span v-if="s.isFill===0">
              {{s.enumExtend}}
            </span>
          </div>
          <div class="optional_text_box">
            <div class="optional_text" v-for="(y,ind3) in s.children" :key="ind3" @click="AddCheckIcon(y)">
              <div :class="{'optional_img':true,'active_optional_img':GetDryActive(IconList.checkIcon,y.configId)}">
                <img :src="y.enumName" alt=""  />
              </div>
              <div :class="{'optional_remake':true,'Active_Remake':GetDryActive(IconList.checkIcon,y.configId)}">
                {{y.remark}}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="Optional_icon" v-if="IconList.iconKey==='ICON.SL_BLEACH_USA' || IconList.iconKey==='ICON.SL_IRONING_USA'">
        <div v-for="(s,ind2) in IconList.AllIconList" :key="ind2" class="Optional_icon_list"  @click="AddCheckIcon(s)">
          <div class="optional_check">
            <div v-if="GetActive(IconList.checkIcon,s.configId)" class="optional_check_icon">
              <img src="../../assets/images/check_true.png" />
            </div>
            <div v-else class="optional_check_icon">
              <img src="../../assets/images/check_false.png" />
            </div>
          </div>
          <div class="optional_text">
            <div class="optional_img">
              <img :src="s.enumName" alt=""  />
            </div>
            <div :class="{'optional_remake':true}">
              <!--                'Active_Remake':GetActive(IconList.checkIcon,s.configId)-->
              {{s.remark}}
            </div>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addIcon">确 定</el-button>
      </span>
    </el-dialog>
  </div>


</template>

<script>

import {GetProductBatch, qryNAMakeToolRecord, saveMakeToolRecordUSA} from "src/request/apis";
import Cookies from "js-cookie";

export default {
  name: "WashingMarkForm1",
  components:{
  },
  props: {
    rowNum:{
      type:Number,
      default:24
    },
    CheckFormPass:{
      type:Function,
      default:null
    },
    CloseLoading:{
      type:Function,
      default:null
    },
    GetData:{
      type:Function,
      default:null
    },
    JumpPersonalCenter:{
      type: String,
      default: ()=>''
    },
    apiHost: {
      type: String,
      default: ()=>''
    }
  },
  data() {
    return {
      checked: true,
      dialogVisible: false,
      PageLoading:false,
      SizeDialogVisible:false,
      LocalKey:'WashSelectTypeSize',
      IconList:{},
      IconListIndex:0,
      ruleForm: {
        MODEL_TYPE: '',
        COMPONENT: [],
        textarea:'',
        showMode:1,
        AllIconList:[]
      },
      rules: {
        // MODEL_TYPE: [
        //   { required: true, message: '请输入号型规格', trigger: 'blur' },
        // ],
      },
      AllIconType:[
        {
          name:'水洗',
          iconKey:'ICON.SL_WATER_USA',
          multiple:false
        },
        {
          name:'漂白',
          iconKey:'ICON.SL_BLEACH_USA',
          multiple:false
        },
        {
          name:'干燥',
          iconKey:'ICON.SL_DRY_USA',
          multiple:true
        },
        {
          name:'熨烫',
          iconKey:'ICON.SL_IRONING_USA',
          multiple:false
        },
        {
          name:'干洗',
          iconKey:'ICON.SL_DRY_CLEAN_USA',
          multiple:true
        }
      ],
      currenticonlist:[],
      history:{},
      GetIconListValue:[
        {
          tableName:'ICON',
          colName:'SL_WATER_USA'
        },
        {
          tableName:'ICON',
          colName:'SL_BLEACH_USA'
        },
        {
          tableName:'ICON',
          colName:'SL_DRY_USA'
        },
        {
          tableName:'ICON',
          colName:'SL_IRONING_USA'
        },
        {
          tableName:'ICON',
          colName:'SL_DRY_CLEAN_USA'
        }
      ],
      multipleTypeList:[
        {
          idList:[2283,2284,2285,2286,2287,2288,2289,2290,2291,2292,2293,2294,2295],
          type:1
        },
        {
          idList:[2296,2297,2298,2299,2300,2301],
          type:2
        }
      ],
      multipleTypeList2:[
        {
          idList:[2302,2303,2304,2305,2306,2307,2308,2309,2310],
          type:1
        },
        {
          idList:[2311],
          type:2
        }
      ]

    };
  },
  watch:{
    ruleForm:{
      handler(newVal){
        let data=[
          {
            label:'Size',
            value:newVal.MODEL_TYPE,
            required: false
          },
          {
            label:'Fiber Content',
            value:this.ComponentContent(newVal.COMPONENT),
            required: false,
          },
          {
            label:'Washing Instructions',
            value:newVal.AllIconList,
            typeImg:true,
            required: true,
            showMode:newVal.showMode
          },
          {
            label:'洗涤提醒',
            value:newVal.textarea,
            required: false,
          }
        ]
        this.GetData(data)
        let form=this.WashFormData()
        let accessToken = Cookies.get('SSO_TOKEN')
        if(form&&accessToken) localStorage.setItem('label3',JSON.stringify(form))
        
      },
      deep:true
    }
  },
  mounted() {
    this.GetProductList(this.GetIconListValue)
  },
  created() {
    this.$nextTick(()=>{
      document.addEventListener("click", e => {
        let list = document.getElementById("showDiv");
        if (list&&list.contains(e.target)) {
        } else {
          this.ruleForm.AllIconList.map((v,index)=>{
            this.$set(this.ruleForm.AllIconList[index],'CheckShow',false)
          })
        }
      })
    })
  },
  methods: {
    //水洗弹窗验证已选中图标
    GetWaterActive(list,code){
      return list.some(item => {
        if (item.enumCode === code) {
          return true
        }
      })
    },
    //多选验证已选中图标
    GetDryActive(list,id){
      return list.some(item => {
        if (item.configId === id) {
          return true
        }
      })
    },
    GetActive(list,id){
      return list.some(item => {
        if (item.configId === id) {
          return true
        }
      })
    },
    //获取历史form数据
    GetFormList(AllIconList){
      this.PageLoading=true
      let that=this
      qryNAMakeToolRecord({
        toolCode:'SL_TOOLKIT006',
        makeType:"100"
      },that.apiHost).then(res=>{
        if(res&&res.data){
            let list=res.data
            this.AssembleFormData(list, AllIconList)
        }else{
          let tempFrom = {
            AllIconList : AllIconList,
            textarea: '',
            MODEL_TYPE: '',
            showMode:1,
            COMPONENT: [
              {
                attrValue:'',
                attrRate:''
              }
            ]
          }
          this.ruleForm = JSON.parse(JSON.stringify((tempFrom)))
        }
        that.PageLoading=false
      }).catch(err=>{
        if(err.resultCode==='6001'){
          that.$router.push({
            path:that.JumpPersonalCenter
          })
        }
        that.PageLoading=false
      })
    },
    //处理缓存form数据  或者后端返回数据
    AssembleFormData(arr,AllIconList){
      let list=arr.normalList
      let tempFrom = {
        AllIconList : JSON.parse(JSON.stringify((AllIconList))),
        textarea: '',
        showMode:Number(arr.showMode) || 1,
        MODEL_TYPE:'',
        COMPONENT: [
          {
            attrValue:'',
            attrRate:''
          }
        ]
      }
      list.forEach((item, itemIndex)=>{
        if(item.attrCode==='NOTES'){
          tempFrom.textarea= item.attrValue
        }else if(item.attrCode==='MODEL_TYPE'){
          tempFrom.MODEL_TYPE= item.attrValue
        }else if(item.attrCode==='COMPONENT'){
          let arr=[]
          item.items.forEach(s=>{
            arr.push({
              attrRate: s.attrRate,
              attrValue: s.attrValue
            })
          })
          tempFrom.COMPONENT=arr
        }else{
          tempFrom.AllIconList.forEach((s,index)=>{
            if (item.attrCode !== 'ICON') {
              if (s.iconKey===item.attrCode){
                let arr1=[]
                let arr2=[]
                item.items.forEach(obj => arr2.push(obj.attrValue))
                console.log(arr2,s.iconKey)
                s.AllIconList.forEach(obj=>{
                  if(obj.children){
                      obj.children.forEach(x=>{
                        if(arr2.indexOf(x.enumCode) !== -1){
                          arr1.push(x)
                        }
                      })
                  }else{
                    if(arr2.indexOf(obj.enumCode) !== -1){
                      arr1.push(obj)
                    }
                  }
                })
                if(arr1){
                  tempFrom.AllIconList[index]['checkIcon'] = arr1
                }else{
                  tempFrom.AllIconList[index]['checkIcon'] = s.AllIconList[0]
                }
              }
            } else {
              item.items.forEach(v1 => {
                tempFrom.AllIconList.forEach(v2 => {
                  if (v1.iconKey === v2.iconKey && v2.checkIcon.length)
                    v2.checkIcon = v1.checkIcon
                })
              })
            }
          })
        }
      })
      console.log(tempFrom)
      this.ruleForm = JSON.parse(JSON.stringify((tempFrom)))
      let fromUrl=this.$route.query.fromPage
      if(fromUrl){
        this.ruleForm.COMPONENT=JSON.parse(localStorage.getItem('WashSelectTypeSize')).Ingredients
      }
    },
    //点击图标显示图标列表
    ChangeIcon(item,ind){
      this.IconList=JSON.parse(JSON.stringify(item))
      this.dialogVisible=true
      this.IconListIndex=ind
    },
    AddWaterCheckIcon(s,y){
      this.$set(this.IconList.checkIcon,0,y)
    },
    //追加图标
    AddCheckIcon(s){
      if(!this.IconList.multiple){
        //单选
        this.$set(this.IconList.checkIcon,0,s)
      }else{
          let currentList=this.IconList.checkIcon
          let ind=currentList.findIndex(v=>{
            return  v.configId===s.configId
          })
          if(ind>=0){
            if(this.IconList.checkIcon.length===1){
              this.$message('最少选择1个')
            }else {
              currentList.splice(ind,1)
            }
          }else{
            currentList.forEach((x,index)=>{
              if(x.type===s.type){
                this.$set(currentList,index,s)
              }else{
                if(currentList.length<2){
                  currentList.push(s)
                }else{
                  // this.$message('最多可选2个')
                }
              }
            })
          }
          this.$set(this.IconList,'checkIcon',currentList)
      }
    },
    addIcon(){
      this.$set(this.ruleForm.AllIconList,this.IconListIndex,this.IconList)
      this.dialogVisible=false
    },
    //成分含量解构
    ComponentContent(list){
      let arr=[]
      if(list){
        list.forEach(item=>{
          if(item.attrValue){
            arr.push(`<div>${item.attrValue} ${item.attrRate}%</div>`)
          }
        })
      }
      return arr.join('')
    },
    ChangeValue(index){
      let data=this.ruleForm.COMPONENT
      this.$nextTick(() => {
        data=parseFloat(data)
        data[index].attrRate=parseFloat(data.toFixed(2))
      })
    },
    //验证成分含量
    CheckComponentContent(){
      let data=this.ruleForm.COMPONENT
      let isEmpty=true //是否所有输入框填写
      let isContent=true //含量100
      if(data.length===1&&data[0].attrValue===''&& !data[0].attrRate){
          this.FormatFormData()
      }else{
        for(let i in data){
          let object=data[i]
          for (const key in object) {
            if (object.hasOwnProperty(key)) {
              if (object[key] === null || object[key] === '') {
                isEmpty=false
                break
              }else{
                isEmpty=true
              }
            }
          }
        }
        if(isEmpty){
          let sum=0
          for(let i in data){
            sum+=Number(data[i].attrRate)
          }
          if(sum !==100){
            isContent=false
          }
        }
        if(!isEmpty){
          this.CloseLoading()
          return this.$message({
            message: '请填写成分含量',
            type: 'warning'
          });
        }
        if(!isContent){
          this.CloseLoading()
          return this.$message({
            message: '成分含量的合计应为100%，请重新输入',
            type: 'warning'
          });
        }
        if(isEmpty&&isContent){
          this.FormatFormData()
        }
      }
    },
    //获取图片枚举值
    GetProductList(data){
      GetProductBatch(data,this.apiHost).then((res) => {
        let AllIconList=[]
        if(res&&res.data){
          for (let item of Object.keys(res.data)){
            let s=this.AllIconType.find(y => y.iconKey === item)
            if(s){
              AllIconList.push({
                iconName:s.name,
                iconKey:item,
                AllIconList:this.ImgFormat(item,res.data[item]),
                checkIcon:[Object.assign(res.data[item][0],{type:1})],
                CheckShow:false,
                multiple:s.multiple
              })

            }
          }
          let list=JSON.parse(localStorage.getItem('label3'))
          if(list){
            this.AssembleFormData(list,AllIconList)
          }else{
            this.GetFormList(AllIconList)
          }
        }
      }).catch((e) => {
        this.loading = false
      })
    },
    //图片数据格式化
    ImgFormat(key,list){
      let arrList=[]
      if(key==='ICON.SL_WATER_USA'){
        arrList=this.FormatImgList(list,0,key)
      }else if(key==='ICON.SL_DRY_USA'){
        arrList=this.FormatImgList(list,1,key)
        arrList=arrList.sort(function (a,b){
          return a.configId - b.configId
        })
      }else if(key==='ICON.SL_DRY_CLEAN_USA'){
        arrList=this.FormatImgList(list,1,key)
        arrList=arrList.sort(function (a,b){
          return a.configId - b.configId
        })
      }else{
        arrList=list
      }
      return arrList
    },
    //特殊格式化干燥等多选数据
    FormatImgList(list,type,key){
      let newList=[]
      list.forEach((item,index)=>{
        let has
        if(type===0){
          has=newList.findIndex(i=> i.enumExtend===item.enumExtend)
        }else{
          has=newList.findIndex(i=> i.enumExtend===item.enumExtend&&i.isFill===item.isFill)
        }
        let arr1=[]
        if(key==='ICON.SL_DRY_USA'){
          arr1=this.multipleTypeList
        }else if(key==='ICON.SL_DRY_CLEAN_USA'){
          arr1=this.multipleTypeList2
        }
        if(has=== -1){
            newList.push({
              enumExtend: item.enumExtend,
              colName: item.colName,
              isFill: item.isFill,
              showSort: item.showSort,
              tableName: item.tableName,
              configId: item.configId,
              remark: item.remark,
              children:[
                {
                  enumExtend: item.enumExtend,
                  colName: item.colName,
                  isFill: item.isFill,
                  showSort: item.showSort,
                  tableName: item.tableName,
                  enumCode:item.enumCode,
                  enumName:item.enumName,
                  remark: item.remark,
                  configId: item.configId,
                  type:this.filterType(item.configId,arr1) || 1
                }
              ]
            })
        }else{
          newList[has].children.push({
            enumExtend: item.enumExtend,
            colName: item.colName,
            isFill: item.isFill,
            showSort: item.showSort,
            tableName: item.tableName,
            enumCode:item.enumCode,
            enumName:item.enumName,
            remark: item.remark,
            configId: item.configId,
            type:this.filterType(item.configId,arr1) || 1
          })
        }
      })
      return newList
    },
    filterType(id,arr){
      let type
      arr.forEach(item=>{
        if(item.idList.includes(id)){
          type= item.type
        }else{
          type=1
        }
      })
      return type
    },
    //处理回传数据库数据格式
    WashFormData(){
      let {
        COMPONENT,
        AllIconList,
        textarea,
        MODEL_TYPE,
        showMode
      }=this.ruleForm
      return {
        toolCode: "SL_TOOLKIT006",
        makeType: "100",
        state: 1,
        showMode:showMode,
        normalList: [
          {
            attrName: "成分含量",
            attrCode: "COMPONENT",
            items: COMPONENT
          },
          {
            attrName: "号型规格",
            attrCode: "MODEL_TYPE",
            attrValue: MODEL_TYPE || ''
          },
          {
            attrName: "洗涤方法",
            attrCode: "ICON",
            items: AllIconList
          },
          {
            attrName: "洗涤提醒",
            attrCode: "NOTES",
            attrValue: textarea
          }
        ]
      }
    },
    //处理保存数据
    FormatFormData(){
      let FormData=this.WashFormData()
      saveMakeToolRecordUSA(FormData,this.apiHost).then((res) => {
        if(res&&res.resultCode==='0'){
          this.$message.success('保存成功，下载中......');
          this.CheckFormPass()
          localStorage.removeItem('label3')
        }else{
          this.$message.error(res.resultMsg);
        }
      }).catch((e) => {

      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.CheckComponentContent()
        } else {
          this.CloseLoading()
          this.$message('请填写必填项后再下载');
          return false;
        }
      });
    },
    removeDomain(item) {
      let index = this.ruleForm.COMPONENT.indexOf(item)
      if (index !== -1) {
        this.ruleForm.COMPONENT.splice(index, 1)
      }
    },
    addDomain() {
      this.ruleForm.COMPONENT.push({
        attrValue: '',
        attrRate:'',
        key: Date.now()
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.card_form_box{
  display: flex;
  background: #FFFFFF;
  padding-left: 31px;
  padding-top: 20px;
  .certificate {
    flex: 1;
    .certificate_title {
      .title_label {
        font-size: 30px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-bottom: 20px;
      }

      .title_remake {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
      }

    }
    .label_tit{
      font-size: 14px;
      color: #FF0000;
      font-weight: 500;
    }
    .label_number{
      display: flex;
      margin-right: 10px;
      .Symbol{
        width: 40px;
        height: 40px;
        border: 1px solid #cccccc;
        background: #f5f7fa;
        text-align: center;
        border-left: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        color: #747474;
      }
    }
  }
}

.Size_pos{
  position: relative;
  margin-bottom: 40px;
  .Size_pos_layout{
    position: absolute;
    width: 392px;
    height: 40px;
    z-index: 1;
  }
  .el-input{
    position: absolute;
    z-index: 0;
  }
}
.icon_box{
  display: flex;
  border: 1px solid #D2D2D2;
  border-radius: 5px 0px 0px 5px;
  width: 849px;
  .icon_box_list{
    display: flex;
    flex-direction: column;
    width: 170px;
    height: 128px;
    .icon_name{
      height: 45px;
      background: #F6F6F6;
      border-bottom: 1px solid #D2D2D2;
      border-right:1px solid #D2D2D2;
      text-align: center;
    }
    .check_icon{
      position: relative;
      display: flex;
      width: 169px;
      height: 83px;
      border-right:1px solid #D2D2D2;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .check_img{
        width: 48px;
        height: 48px;
        margin-right: 9px;
        img{
          width: 48px;
          height: 48px;
        }
      }
    }

  }
  .icon_box_list:first-child .icon_name{
    border-radius: 5px 0 0 0;
  }
  .icon_box_list:last-child .icon_name{
   border-right: none;
  }
  .icon_box_list:last-child .check_icon{
    border-right: none;
  }
}
.header-title{
  .name{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    .name_tit{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FF0000;
    }
  }
}
.Optional_icon1{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .Optional_icon_list{
    display: flex;
    align-items: center;
    height: auto;
    min-height: 45px;
    cursor: pointer;
    width: 50%;
    .optional_text{
      display: flex;
      padding: 8px 30px;
      width: 100%;
      .img_list{
        display: flex;
        width: 160px;
        flex-wrap: wrap;
        .list_index{
          display: flex;
          margin-bottom: 5px;
          .optional_img{
            width: 52px;
            height: 52px;
            margin-right: 15px;
            img{
              width: 48px;
              height: 48px;
              object-fit: cover;
            }
          }
          .active_optional_img{
            border-radius: 4px;
            border: 2px solid #CA4301;
          }
          .optional_or{
            width: 20px;
            display: flex;
            align-items: center;

          }
        }

      }


      .optional_remake{
        display: flex;
        align-items: center;
        line-height: 16px;
        width: 50%;
      }
      .Active_Remake{
        color: #CA4300;
      }
    }

  }
  .Optional_icon_close{
    position: absolute;
    top: -22px;
    right: -4px;
    cursor: pointer;
  }
}
.Optional_icon2{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .Optional_icon_list{
    display: flex;
    flex-direction: column;
    height: auto;
    min-height: 45px;
    cursor: pointer;
    width: 42%;
    border: 1px solid #cccccc;
    margin-bottom: 10px;
    padding: 16px 30px;
    margin-right: 20px;
    .title{
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      margin-bottom: 16px;
      height: 24px;
    }
    .optional_text_box{
      display: flex;
      .optional_text{
        display: flex;
        flex-direction: column;
        width: 316px;
        .optional_img{
          width: 52px;
          height: 52px;
          margin-right: 15px;
          img{
            width: 48px;
            height: 48px;
            object-fit: cover;
          }
        }
        .active_optional_img{
          border-radius: 4px;
          border: 2px solid #CA4301;
        }
        .optional_remake{
          display: flex;
          align-items: center;
          line-height: 16px;
          font-size: 14px;
          color: #808080;
          margin-top: 10px;
          width: 100px;
        }
        .Active_Remake{
          color: #CA4300;
        }
      }
    }


  }
  .Optional_icon_close{
    position: absolute;
    top: -22px;
    right: -4px;
    cursor: pointer;
  }
}
.Optional_icon3{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .Optional_icon_list{
    display: flex;
    flex-direction: column;
    height: auto;
    min-height: 45px;
    cursor: pointer;
    width: 42%;
    margin-bottom: 10px;
    padding: 16px 30px;
    margin-right: 20px;
    .title{
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      margin-bottom: 16px;
      height: 24px;
    }
    .optional_text_box{
      display: flex;
      .optional_text{
        display: flex;
        flex-direction: column;
        width: 316px;
        .optional_img{
          width: 52px;
          height: 52px;
          margin-right: 15px;
          img{
            width: 48px;
            height: 48px;
            object-fit: cover;
          }
        }
        .active_optional_img{
          border-radius: 4px;
          border: 2px solid #CA4301;
        }
        .optional_remake{
          display: flex;
          align-items: center;
          line-height: 16px;
          font-size: 14px;
          color: #808080;
          margin-top: 10px;
          width: 155px;
        }
        .Active_Remake{
          color: #CA4300;
        }
      }
    }


  }
  .Optional_icon_close{
    position: absolute;
    top: -22px;
    right: -4px;
    cursor: pointer;
  }
}
.Optional_icon{
  border-top: 1px solid #D2D2D2;
  border-left: 1px solid #D2D2D2;
  width: 755px;
  display: flex;
  flex-wrap: wrap;
  .Optional_icon_list{
    display: flex;
    align-items: center;
    border-bottom:1px solid #D2D2D2;
    border-right:1px solid #D2D2D2;
    height: auto;
    min-height: 45px;
    cursor: pointer;
    width: 376px;
    .optional_check{
      width: 60px;
      height: 45px;
      border-right: 1px solid #D2D2D2;
      .optional_check_icon{
        display: flex;
        justify-content: center;
        padding-top: 14px;
      }
    }
    .optional_text{
      display: flex;
      padding: 0 30px;
      width: 316px;
      .optional_img{
        width: 52px;
        height: 52px;
        margin-right: 15px;
        img{
          width: 48px;
          height: 48px;
          object-fit: cover;
        }
      }
      .optional_remake{
        display: flex;
        align-items: center;
        line-height: 16px;
      }
      .Active_Remake{
        color: #CA4300;
      }
    }

  }
  .Optional_icon_close{
    position: absolute;
    top: -22px;
    right: -4px;
    cursor: pointer;
  }
}
::v-deep .label_number .el-input__inner{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
::v-deep .el-form-item__label{
  color: #333333;
  font-weight: bold;
  padding: 10px 0 20px 0;
  line-height: 0;
}
::v-deep .el-form-item{
  margin-bottom: 16px;
}
</style>